import { ValidationResult } from '../../../../../../ui/gzForm/formField/types/form-validator';
import { translateFn } from '../../../../../../utils/translator.helper';

// see passwordComplexity from ExtJs
const PASSWORD_MAX_LENGTH = 128;
const PASSWORD_MIN_LENGTH = 6;

export function validatePasswordComplexity(val: string): ValidationResult {
  // default password
  if (val === '********') {
    return { valid: true };
  }

  // validate min length
  if (val.length >= 1 && val.length < PASSWORD_MIN_LENGTH) {
    return {
      valid: false,
      error: translateFn('Password must be at least {minLength} characters in length.', {
        minLength: PASSWORD_MIN_LENGTH,
      }),
    };
  }

  // validate max length
  if (val.length >= 1 && val.length > PASSWORD_MAX_LENGTH) {
    return {
      valid: false,
      error: translateFn('The password must not exceed {maxLength} characters.', { maxLength: PASSWORD_MAX_LENGTH }),
    };
  }

  const regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[~!@#$%^&*_\-+=`|(){}\[\]:;"'<>,.?\/]).*$/;
  if (!regex.test(val)) {
    return {
      valid: false,
      error: translateFn(
        'The password must contain at least one digit, one upper case, one lower case and one special character.'
      ),
    };
  }

  return { valid: true };
}

// see credentialsadusername from ExtJs
export function validateCredentialsUsername(val: string): ValidationResult {
  if (val.indexOf('\\') !== -1) {
    const netBiosName = val.substring(0, val.indexOf('\\'));

    if (netBiosName.length > 64) {
      return { valid: false, error: translateFn('Invalid username') };
    }
  }

  return { valid: true };
}
